import { CheckBadgeIcon, CheckCircleIcon } from '@heroicons/react/20/solid';

import { TImageTokenWithFile } from '@northladder/apis';
import { Text } from '@northladder/i18n';

import { translations } from '../../../translations';

interface IImageUploadStatusBadgeProps {
  status: TImageTokenWithFile['status'];
}

/**
 * -----------------------------------------------------------------------------
 * This displays the status of the upload. Whether an image has been attached,
 * uploaded or an failed to.
 */
export function ImageUploadStatusBadge({
  status,
}: IImageUploadStatusBadgeProps) {
  switch (status) {
    case 'completed': {
      return (
        <span className="status-badge upload-completed">
          <CheckBadgeIcon className="h-5 w-5" />
          <span className="mx-1">
            <Text text={translations.uploadStatus.uploadCompleted} />
          </span>
        </span>
      );
    }
    case 'upload-failed': {
      return (
        <span className="status-badge upload-failed">
          <CheckCircleIcon className="h-5 w-5" />
          <span className="mx-1">
            <Text text={translations.uploadStatus.uploadFailed} />
          </span>
        </span>
      );
    }
    case 'upload-success': {
      return (
        <span className="status-badge upload-success">
          <CheckCircleIcon className="h-5 w-5" />
          <span className="mx-1">
            <Text text={translations.uploadStatus.uploadSuccess} />
          </span>
        </span>
      );
    }

    case 'pending':
    default: {
      return (
        <span className="status-badge upload-pending">
          <CheckCircleIcon className="h-5 w-5" />
          <span className="mx-1">
            <Text text={translations.uploadStatus.uploadPending} />
          </span>
        </span>
      );
    }
  }
}
